import { styled, useTheme } from "@infinitaslearning/pixel-design-system/styles";
export const StyledIcon = styled("i", {
    shouldForwardProp: (prop) => prop !== "src" && prop !== "color" && prop !== "fontSize" && prop !== "htmlColor" && prop !== "sx" && prop !== "backgroundColor",
})(({ src, color, htmlColor, fontSize = "medium", sx }) => {
    const { pixel } = useTheme();
    const size = pixel?.icon?.size?.[fontSize] ?? "20px";
    const backgroundColor = htmlColor ||
        (color === "primary" && pixel?.color?.primary?.key) ||
        (color === "secondary" && pixel?.color?.secondary?.key) ||
        (color === "success" && pixel?.color?.signal?.success?.key) ||
        (color === "error" && pixel?.color?.signal?.error?.key) ||
        (color === "warning" && pixel?.color?.signal?.warning?.key) ||
        (color === "info" && pixel?.color?.signal?.info?.key) ||
        (color === "inverted" && pixel?.color?.surface?.key) ||
        (color === "disabled" && pixel?.cta?.outlined?.color?.text?.primary?.disabled) ||
        (color === "neutral" && pixel?.color?.onSurface?.variant) ||
        pixel?.color?.onSurface?.key;
    return {
        height: size,
        width: size,
        display: "inline-block",
        mask: `url("${src}") center / contain no-repeat`,
        ...(htmlColor || color
            ? { "&[class][class][class][class][class][class]": { "background-color": backgroundColor } }
            : { backgroundColor }),
        ...(Array.isArray(sx) ? sx : [sx]),
    };
});
//# sourceMappingURL=StyledIcon.styled.js.map